import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { GlobalLoaderComponent } from './global-loader/global-loader.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
    declarations: [GlobalLoaderComponent],
    imports: [CommonModule, FlexLayoutModule, MatProgressSpinnerModule],
    exports: [GlobalLoaderComponent],
})
export class GlobalLoaderModule {}
